import { get } from "../../service/api";

const GetIncomeTransaction = async (merchantId, merchantSettleId, page = 1, size = 20) => {
    try {
        const response = await get(`/merchant/${merchantId}/merchantSettle/${merchantSettleId}/incomeTransaction?page=${page}&size=${size}`);
        return response;
    } catch (error) {
        console.error('Error GetIncomeTransaction:', error);
        throw error;
    }
};

export default GetIncomeTransaction;
